import AnimatedSuccessIcon, {
  SUCCESS_ANIMATION_DURATION,
} from './AnimatedSuccessIcon';

export { SUCCESS_ANIMATION_DURATION };
export default AnimatedSuccessIcon;
